// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6c1ba48a","787":"8c12c48b"}[chunkId] + ".chunk.js";
};